module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Ga-Ha-Ib-Jb.c0909e98.png";